'use client';

import { Avatar } from '@/components/ui/avatar';
import { getUserDisplay } from '@/shared/utils/user-display';
import type { User } from '@/types';
import { User as UserIcon } from 'lucide-react';
import Link from 'next/link';

export function UserIdentity({ user, onClose }: { user: User; onClose?: () => void }) {
  const displayName = getUserDisplay(user);
  const handler = user.handler;
  const email = user.email;

  return (
    <>
      <Link
        href="/profile"
        {...(onClose !== undefined ? { onClick: onClose } : {})}
        className="px-3 py-3 flex items-center gap-3 hover:bg-white/10 transition-colors"
      >
        <Avatar src={user.dp} alt={displayName} size="md" fallback={displayName} />
        <div className="min-w-0 flex-1">
          <p className="font-semibold text-white truncate">{displayName}</p>
          <p className="text-xs text-white/50 truncate">{handler ? `@${handler}` : email}</p>
        </div>
      </Link>

      <div className="h-px bg-white/10 -mx-1 my-1" />

      <Link
        href="/profile"
        {...(onClose !== undefined ? { onClick: onClose } : {})}
        className="mx-2 flex items-center gap-3 rounded px-2 py-2 text-sm hover:bg-white/10 transition-colors"
      >
        <UserIcon className="w-4 h-4" />
        My Profile
      </Link>

      <div className="h-px bg-white/10 -mx-1 my-1" />
    </>
  );
}
